<template>
  <div class="">
    警情跟踪
  </div>
</template>
<script>
// 随机字符串
import getRandVal, { getTime } from '@/assets/js/index'
// 加密
import Base64 from '@/assets/js/base64.js'
import md5 from 'js-md5'
import CryptoJS from '@/assets/js/core.js'
export default {
  name:"",    
  data: () => ({
    hashValue: '',
    loginData: {},
    currentPage: 1,
  }),
  components: {

  },
  created() {
    this.hashValue = localStorage.getItem('hashValue');
    this.loginData = JSON.parse(localStorage.getItem('loginData'));
  },
  mounted() {
    this.getData();
  },
  computed: {

  },
  methods: {
    getPwdHash(pwd, data){
        var sha = md5(pwd + data);
        var base = new Base64();
        var pwdHashStr = base.encode(sha);
        return pwdHashStr;
    },
    getData(){
      // 安全指数
      let dataObj = {
          type: 'get',
          url: '/mcbw/hidden_hazard', 
          obj: {
            "pageSize":10,
            "currentPage":1,
            "orgId":149132,
            "beginTime":null,
            "endTime":null,
            "state":null,
            "type":null,
            "content":null
          }
      }
      this.$Axios(dataObj).then((res)=>{
          console.log('安全指数接口');
          console.log(res);
      });
    }
  }
}
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/pages/index/info-track.vue